import {
  ApiGetRequest,
  ApiPutRequest,
  ApiPostMultipart,
  ApiPostRequest,
  ApiDeleteRequest,
} from '../../../api';
import { showNotif } from '../../notification';
// import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Container Survey',
    breadcrumbs: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Survey',
        href: '/adm/opr/pti/survey',
        active: true,
      },
    ],
    title_form_survey: 'Form Container Survey PTI',
    breadcrumbs_survey: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Survey PTI',
        href: '/adm/opr/pti/survey',
        active: true,
      },
    ],
    modal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: true,
    fields: [
      {
        key: 'code_survey',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'survey_date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'condition',
        label: 'Condition',
        sortable: false,
      },
      {
        key: 'need_pti',
        label: 'Status',
        sortable: false,
      },
      {
        key: 'code_pti',
        label: 'PTI',
        sortable: false,
      },
      {
        key: 'aksi',
      },
    ],
    form: {
      container: '',
      size: '',
      type: '',
      condition: '',
      cleaning: '',
      place_interchange: 'EMPTY',
      is_for_eor: 0,
      need_pti: 0,
      mgw: '',
      tare: '',
      payload: '',
      nopol: '',
      sopir: '',
      date_manifest: '',
      grade: '',
      lokasi: '',
      pelabuhan: '',
      tgl_pelabuhan: '',
      photo_survey: [],
      damages: [],
    },
    form_damage: {
      loc: '',
      comp: '',
      dmg_width: '',
      dmg_height: '',
      dmg_unit: '',
      qty: '',
      account: '',
      dmg_type: '',
      action_repair: '',
      photo_damage: [],
    },
    detail: false,
    data_loc: [],
    page_loc: 1,
    limit_loc: 10,
    total_loc: 0,
    search_loc: '',
    sortBy_loc: 'id_location',
    sortDesc_loc: false,
    fields_loc: [
      {
        key: 'code_loc',
        label: 'Kode',
        sortable: true,
        thStyle: {
          width: '100px',
        },
      },
      {
        key: 'location',
        label: 'Location Repair',
        sortable: true,
      },
      {
        key: 'aksi',
        thStyle: {
          width: '100px',
        },
      },
    ],

    items_location: [],
    form_comp: {
      code: '',
      location: '',
      name: '',
    },
    data_comp: [],
    page_comp: 1,
    limit_comp: 10,
    total_comp: 0,
    search_comp: '',
    sortBy_comp: 'id_component',
    sortDesc_comp: false,
    fields_comp: [
      {
        key: 'code_comp',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'location',
        label: 'Location Repair',
        sortable: true,
      },
      {
        key: 'component',
        label: 'Component Repair',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],

    items_component: [],
    select_component: false,
    form_dmg: {
      code: '',
      component: '',
      name: '',
    },
    data_dmg: [],
    page_dmg: 1,
    limit_dmg: 10,
    total_dmg: 0,
    search_dmg: '',
    sortBy_dmg: 'id_damage',
    sortDesc_dmg: false,
    fields_dmg: [
      {
        key: 'code_dmg',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'damage',
        label: 'Damage Repair',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],

    data_ar: [],
    items_damage: [],
    form_ar: {
      code: '',
      damage: '',
      name: '',
    },
    page_ar: 1,
    limit_ar: 10,
    total_ar: 0,
    search_ar: '',
    sortBy_ar: 'id_repair',
    sortDesc_ar: false,
    fields_ar: [
      {
        key: 'code_repair',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'action_repair',
        label: 'Action Repair',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  form_damage(state) {
    return state.data.form_damage;
  },
};

export const mutations = {
  changeSurveyPti(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchContainerPti({ commit, state }, payload = null) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/pti-survey/search`, {
      q: payload?.value || '',
    });

    commit('changeSurveyPti', {
      loading: false,
    });

    if (!result.error) {
      commit('changeSurveyPti', {
        container_info: result.data.object || false,
        form: {
          ...data.form,
          ...result.data.object,
        },
      });
    }
  },

  async getMasterComponent({ commit, state }, payload = null) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search_comp,
      page: data.page_comp,
      limit: data.limit_comp,
      sort: data.sortBy_comp,
      order: data.sortDesc_comp ? 'desc' : 'asc',
    };

    if (payload) {
      params = {
        ...params,
        ...payload,
      };
    }

    let result = await ApiGetRequest(`opr/repair/component`, params);
    if (!result.error) {
      commit('changeSurveyPti', {
        loading: false,
        data_comp: result.data.object || [],
        total_comp: result.data?.total || 0,
      });
    }
  },

  async getMasterDamage({ commit, state }, payload = null) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search_dmg,
      page: data.page_dmg,
      limit: data.limit_dmg,
      sort: data.sortBy_dmg,
      order: data.sortDesc_dmg ? 'desc' : 'asc',
    };

    if (payload) {
      params = {
        ...params,
        ...payload,
      };
    }

    let result = await ApiGetRequest(`opr/repair/damage`, params);
    if (!result.error) {
      commit('changeSurveyPti', {
        loading: false,
        data_dmg: result.data.object || [],
        total_dmg: result.data?.total || 0,
      });
    }
  },

  async getMasterLocation({ commit, state }, payload = null) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search_loc,
      page: data.page_loc,
      limit: data.limit_loc,
      sort: data.sortBy_loc,
      order: data.sortDesc_loc ? 'desc' : 'asc',
    };

    if (payload) {
      params = {
        ...params,
        ...payload,
      };
    }

    let result = await ApiGetRequest(`opr/repair/location`, params);
    if (!result.error) {
      commit('changeSurveyPti', {
        loading: false,
        data_loc: result.data.object || [],
        total_loc: result.data?.total || 0,
      });
    }
  },

  async getMasterAction({ commit, state }, payload = null) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search_ar,
      page: data.page_ar,
      limit: data.limit_ar,
      sort: data.sortBy_ar,
      order: data.sortDesc_ar ? 'desc' : 'asc',
    };

    if (payload) {
      params = {
        ...params,
        ...payload,
      };
    }

    let result = await ApiGetRequest(`opr/repair/action`, params);
    if (!result.error) {
      commit('changeSurveyPti', {
        loading: false,
        data_ar: result.data.object || [],
        total_ar: result.data?.total || 0,
      });
    }
  },

  async getDetailSurvey({ commit, state }, payload = null) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiGetRequest(`opr/pti-survey/${payload.id}`);
    if (!result.error) {
      commit('changeSurveyPti', {
        form: {
          ...data.form,
          ...result.data.object,
        },
        loading: false,
      });

      return true;
    }

    commit('changeSurveyPti', {
      loading: false,
    });

    return false;
  },

  async getListSurveyPTI({ commit, state }) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/pti-survey`, params);
    commit('changeSurveyPti', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async updateContainerPti({ commit, dispatch }, payload = null) {
    commit('changeSurveyPti', {
      loading: true,
    });

    let result = await ApiPutRequest(`opr/pti-survey/${payload.id}`);
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      commit('changeSurveyPti', {
        loading: false,
        form: {},
      });

      return true;
    }

    return false;
  },

  async changeFileDamage({ commit, state }, payload) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload.form);
    commit('changeSurveyPti', {
      loading: false,
    });

    if (!result.error) {
      let data_form = data.form;
      let photo_damage = data_form.damages[payload.index].photo_damage || [];
      photo_damage[payload.changeId] = result.data.object;

      commit('changeSurveyPti', {
        form: data_form,
      });
    }
  },

  async uploadImageSurvey({ commit, state }, payload) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeSurveyPti', {
      loading: false,
    });

    if (!result.error) {
      let photo_survey = data.form.photo_survey || [];
      photo_survey.push(result.data.object);

      commit('changeSurveyPti', {
        form: {
          ...data.form,
          photo_survey,
        },
      });
    }
  },

  async uploadImageSurveyDamage({ commit, state }, payload) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeSurveyPti', {
      loading: false,
    });

    if (!result.error) {
      let photo_damage = data.form_damage.photo_damage || [];
      photo_damage.push(result.data.object);

      commit('changeSurveyPti', {
        form_damage: {
          ...data.form_damage,
          photo_damage,
        },
      });
    }
  },

  async uploadImageSurveyDamageMore({ commit, state }, payload) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload.form);
    commit('changeSurveyPti', {
      loading: false,
    });

    if (!result.error) {
      let data_form = data.form;
      let photo_damage = data_form.damages[payload.index].photo_damage || [];
      photo_damage.push(result.data.object);

      commit('changeSurveyPti', {
        form: data_form,
      });
    }
  },

  async uploadImageSurveySignature({ commit, state }, payload) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeSurveyPti', {
      loading: false,
    });

    if (!result.error) {
      commit('changeSurveyPti', {
        form: {
          ...data.form,
          imageSignature: result.data.object,
        },
      });
    }
  },

  async createSurveyData({ commit, state, dispatch }) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostRequest(`opr/pti-survey`, data.form);
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    commit('changeSurveyPti', {
      loading: false,
    });

    return false;
  },

  async updateSurveyData({ commit, state, dispatch }, payload = null) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPutRequest(
      `opr/pti-survey/${payload.id}`,
      data.form
    );
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    commit('changeSurveyPti', {
      loading: false,
    });

    return false;
  },

  async deleteSurveyData({ commit, dispatch }, payload = null) {
    commit('changeSurveyPti', {
      loading: true,
    });

    const result = await ApiDeleteRequest(`opr/pti-survey/${payload.id}`);
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    commit('changeSurveyPti', {
      loading: false,
    });

    return false;
  },
};
